import { useContext, useMemo, type FC } from 'react';
import { useSelector } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import { getCoreLevel } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { useTranslation } from 'react-i18next';
import CoreSymbol from '@wix/da-ds/pkg/Indicators/CoreSymbol';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { Url } from '@wix/da-url';
// import { getVideoCreatorRestrictions } from '../../../selectors/studio';

import s from './CoreBanner.scss';

export interface Props {
  currentUser?: PapiUser;
}

const CoreBanner: FC<Props> = ({ currentUser }) => {
  const { t } = useTranslation();
  const { hasCoreMembership } = useContext(SessionContext);
  const coreLevel = useSelector(getCoreLevel);
  // const { video_prompts_remaining } = useSelector(getVideoCreatorRestrictions);

  const video_prompts_remaining = 0;

  const nonCoreNoPrompts = useMemo(() => {
    if (!hasCoreMembership) {
      return video_prompts_remaining < 1;
    } else {
      return false;
    }
  }, [hasCoreMembership, video_prompts_remaining]);
  const hasMax = coreLevel === 'core_max';

  if (hasMax) {
    return null;
  }

  return (
    <div className={s['root']}>
      {nonCoreNoPrompts ? (
        <div>
          <span className={s['no-prompts']}>
            {t('studio.videoCreator.button.noPrompts')}
          </span>

          <CoreSymbol className={s['core-icon']} size={IconSize.SMALL} />
          <div className={s['upsell']}>
            {t('studio.videoCreator.button.upsellNonCore')}
          </div>
          <BrandedButton size="small" variant="core-orange">
            {t('studio.videoCreator.coreUpsell.upgradeLink.nonCore')}
          </BrandedButton>
        </div>
      ) : (
        <div>
          <CoreSymbol className={s['core-icon']} size={IconSize.SMALL} />
          <div className={s['upsell']}>
            {t('studio.videoCreator.button.upsellCore')}
          </div>
          <BrandedButton
            size="small"
            variant="core-orange"
            className={s['coreUpgradeButton']}
            href={Url.coreMembershipLink()}
            target="_blank"
          >
            {t('studio.videoCreator.button.upgradePlan')}
          </BrandedButton>
        </div>
      )}
    </div>
  );
};

CoreBanner.displayName = 'CoreBanner';
export default CoreBanner;
